<!-- <div class="dx-card wide-card" id="root-container"> -->
<dx-accordion #filtersAccordion
[collapsible]="true"
[multiple]="false"
[animationDuration]="500"
itemTitleTemplate="custItemTitleTemplate">    
    <div *dxTemplate="let data of 'custItemTitleTemplate'">
        <span class="main-title ap-green">CRM Data by Zip or Territory</span>
    </div>
    <dxi-item>
    <div *dxTemplate>
    <!-- <h4 class="content-block ap-green">CRM Data by Zip or Territory</h4> -->
    <div style="margin-bottom: 20px"></div>
    <div class="content-block">
        <dx-responsive-box singleColumnScreen="xs sm md">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-col [ratio]=".4"></dxi-col>
            <dxi-col [ratio]=".5"></dxi-col>

            <dxi-item style="margin-right: 20px">
                <dxi-location [row]="0" [col]="0"></dxi-location>
                <div class="card" [class.valdnError]="requestedReportError">
                    <div class="card-body">
                        <h5 class="card-title" style="width: fit-content">Requested Reports<span class="error"> *</span></h5>
                        <dx-list #reportList [dataSource]="reports" [height]="330" [selectionMode]="'multiple'"
                            [selectAllMode]="'allPages'" [showSelectionControls]="true" (onSelectionChanged)="onReportSelectionChanged($event)">
                            <dx-validator #reportListValidator [adapter]="adapterConfig" 
                                validationGroup="validationGroup" 
                                (onValidated)="onReportListValidated($event)">
                                <dxi-validation-rule type="custom" [validationCallback]="validationCallback"></dxi-validation-rule>
                            </dx-validator>
                        </dx-list>
                    </div>
                </div>
            </dxi-item>
            <dxi-item>
                <dxi-location [row]="0" [col]="1"></dxi-location>
                <div class="card" style="height: 120px;">
                    <div class="card-body">
                        <h5 class="card-title" style="width: fit-content">Major Segment<span class="error" *ngIf="majorSegmentRequired"> *</span></h5>                        
                        <div style="margin-bottom: 40px"></div>
                        <dx-drop-down-box #segmentDropDown [(value)]="segmentValue" placeholder="Select a value..."
                            [showClearButton]="true" [dataSource]="segments" valueExpr="majorSegmentId"
                            displayExpr="name" (onValueChanged)="onDropDownBoxValueChanged($event)" 
                            validationMessagePosition="top">
                            <div *dxTemplate="let data of 'content'">
                                <dx-list #segmentlist [dataSource]="segments" [height]="300" [selectionMode]="'all'"
                                    [selectAllMode]="'allPages'" [showSelectionControls]="true"
                                    keyExpr="majorSegmentId" displayExpr="name"                                     
                                    (onSelectionChanged)="onsegmentListSelectionChanged($event)"
                                    (onSelectAllValueChanged)="onSegmentListSelectAllChanged($event)"                                    
                                    scrollingEnabled="true">
                                </dx-list>
                            </div>
                            <dx-validator #segmentValidator [adapter]="adapterConfig_segmentList" 
                                (onValidated)="onSegmentSelectValidated($event)">
                                <dxi-validation-rule type="custom" [validationCallback]="validationCallback_segmentList"></dxi-validation-rule>
                            </dx-validator>
                        </dx-drop-down-box>
                        <div style="margin-top: 40px"></div>                                                
                    </div>
                    
                </div>
                <div style="margin-bottom: 20px"></div>
                <div class="card" style="margin-top: 15px; height: 100px;">
                    <div class="card-body">
                        <h5 class="card-title" style="width: fit-content">Gas Plant</h5>
                        <div style="margin-bottom: 20px"></div>
                        <dx-radio-group [dataSource]="gasPlants" valueExpr="value" displayExpr="name"
                            [(value)]="gasPlantSelected" layout="horizontal"
                            (onValueChanged)="onGasPlantValueChanged($event)">
                        </dx-radio-group>
                    </div>
                </div>
                <div class="card" style="margin-top: 15px" [hidden]="true">
                    <div class="card-body">
                        <div class="column-layout">
                            <div class="row-layout">
                                <dx-check-box [(value)]="checkContractExpires" 
                                    [disabled]="!enableContractExpires" 
                                    text="Where contract expires within"                                    
                                    (onValueChanged)="onChanged_contractExpires($event)">
                                </dx-check-box>
                                <div style="margin-right: 10px"></div>
                                <dx-number-box [(value)]="contractExpMonthsValue" [min]="1" [max]="100"
                                    format="##0" [showSpinButtons]="true" [width]="'75px'"
                                    [disabled]="!enableContractExpMonths">
                                </dx-number-box>
                                <span>months</span>
                            </div>
                            <div class="row-layout">
                                <span>(Only applies to Opportunities and Current Customers)</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" style="margin-top: 15px" [hidden]="true">
                    <div class="card-body">
                        <div class="column-layout">
                            <div class="row-layout">
                                <dx-check-box [(value)]="checkCompetitorSupp"
                                    [disabled]="!enableCompetitorSupp"
                                    text="Where competitor or supplier is"
                                    (onValueChanged)="onChanged_competitorSupp($event)">
                                </dx-check-box>
                                <div style="margin-right: 10px"></div>
                                <dx-select-box [items]="competitor_or_supplier_list" 
                                    placeholder="Select a value..."
                                    [disabled]="!enableCompetitorSuppSelect"
                                    [(value)]="competitorSuppValue">
                                    <dx-validator (onValidated)="onCompetitorSuppSelectValidated($event)">
                                        <dxi-validation-rule
                                          type="required" message="">
                                        </dxi-validation-rule>
                                    </dx-validator>
                                </dx-select-box>
                            </div>
                            <div class="row-layout">
                                <span>(Only applies to Opportunities)</span>
                            </div>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item style="margin-top: 20px; margin-right: 20px">
                <dxi-location [row]="1" [col]="0"></dxi-location>
                <div class="column-layout">
                    <div class="row-layout">
                        <span style="min-width: 120px;" class="field-title">Search By</span>
                        <dx-radio-group [items]="searchByOptions" layout="horizontal" [(ngModel)]="searchBy"></dx-radio-group>
                    </div>
                    <div class="card" style="margin-top: 15px" [hidden]="searchBy != 'Territory'">
                        <div class="card-body">
                            <h5 class="card-title" style="width: fit-content">Territory</h5>
                            <div class="column-layout">
                                <div class="row-layout">
                                    <span style="min-width: 120px">Sales Sub-Region</span>
                                    <div style="margin-right: 10px"></div>
                                    <dx-select-box #salesSubRegionBox [dataSource]="salesSubRegions" placeholder="Select a value..."
                                        valueExpr="salesRegionId" displayExpr="name"
                                        (onValueChanged)="onChanged_salesRegion($event)"></dx-select-box>
                                </div>
                                <div style="margin-top: 10px"></div>
                                <dx-check-box [(value)]="doAllSalesRegionAcctsOnly" text='Do all "{{currSalesRegion}}" CRM accounts only'></dx-check-box>
                                <div style="margin-top: 10px"></div>
                                <div class="row-layout">
                                    <span style="min-width: 120px">Territory</span>
                                    <div style="margin-right: 10px"></div>
                                    <dx-select-box #territoryBox [dataSource]="territories" placeholder="Select a value..."
                                        valueExpr="territoryId" displayExpr="territoryName"
                                        ></dx-select-box>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card" style="margin-top: 15px" [hidden]="searchBy != 'Radius Around Zip'">
                        <div class="card-body">
                            <h5 class="card-title" style="width: fit-content">Radius Around Zip</h5>
                            <div class="column-layout">
                                <div class="row-layout">
                                    <span style="min-width: 120px">Country</span>
                                    <div style="margin-right: 10px"></div>
                                    <dx-select-box #countriesBox [dataSource]="radiusCountries" placeholder="Select a value..."
                                        valueExpr="countryId" displayExpr="country">
                                    </dx-select-box>
                                </div>
                                <div style="margin-top: 10px"></div>
                                <div class="row-layout">
                                    <span style="min-width: 120px">Postcode</span>
                                    <div style="margin-right: 10px"></div>
                                    <dx-text-box [width]="'80px'" [maxLength]="10" [(value)]="postCodeValue">
                                        <dx-validator 
                                            (onValidated)="onPostalCodeValidated($event)">
                                            <dxi-validation-rule
                                              type="required" message="">
                                            </dxi-validation-rule>
                                            <dxi-validation-rule
                                              type="stringLength"
                                              [min]="5" message="">
                                            </dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                                <div style="margin-top: 10px"></div>
                                <div class="row-layout">
                                    <span style="min-width: 120px">Radius</span>
                                    <div style="margin-right: 10px"></div>
                                    <dx-number-box [(value)]="radiusMilesValue" [min]="1" [max]="250" 
                                        [showSpinButtons]="true" [width]="'75px'"
                                        format="##0" [disabled]="false">
                                    </dx-number-box>
                                    <span>Miles</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item style="margin-top: 20px; margin-left: 20px; margin-bottom: 20px;">
                <dxi-location [row]="1" [col]="1"></dxi-location>
                <div class="column-layout" style="height: 100%; justify-content: flex-end;">
                    <div *ngIf="validationErrors.length > 0" style="color: red"><b>Validation Error(s):</b></div>
                    <div *ngFor="let error of validationErrors">{{error.message}}</div>
                </div>                
            </dxi-item>
        </dx-responsive-box>        
        <div style="margin-top: 10px"></div>
        <div class="row-center">
            <dx-button class="ap-blue-btn" type="default" [useSubmitBehavior]="true" 
                (onClick)="submit($event)" text="Run Report(s)">
            </dx-button>
        </div>
        <div style="margin-top: 20px"></div>

    </div>
    <dx-popup
    [width]="680"
    [height]="540"
    [showTitle]="true"
    [title]="'Postal Code \'' + postCodeValue + '\' Not Found'"
    [dragEnabled]="false"    
    [showCloseButton]="true"
    [(visible)]="postCodePopupVisible">        
        <div id="postcodes-popup-content" style="height: auto;" *dxTemplate="let data of 'content'">            
            <div style="margin-bottom: 10px;">Please choose a postal code that is closer.</div>
            <dx-data-grid id="gridContainer"
                [dataSource]="postalCodeSearchData"                
                keyExpr="zip"
                [height]="'90%'"
                [allowColumnReordering]="true"
                [showRowLines]="true"
                [showColumnLines]="true"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [rowAlternationEnabled]="true"
                [columnHidingEnabled]="false"
                [allowColumnResizing]="true">

                <dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
                <dxo-header-filter [visible]="showHeaderFilter"></dxo-header-filter>                                
                <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>                
                <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="allowedPageSizes"
                    [showPageSizeSelector]="false"
                    [showInfo]="true"
                    [showNavigationButtons]="false">
                </dxo-pager>            
                <dxo-column-fixing [enabled]="true"></dxo-column-fixing>            
                <div *dxTemplate="let info of 'boldHeaderTemplate'">
                    <b>{{info.column.caption}}</b>
                </div>
                <dxi-column dataField="region1" headerCellTemplate="boldHeaderTemplate" [width]="125" caption="Region1"></dxi-column>
                <dxi-column dataField="region2" headerCellTemplate="boldHeaderTemplate" [width]="125" caption="Region2"></dxi-column>                
                <dxi-column dataField="region3" headerCellTemplate="boldHeaderTemplate" [width]="125" caption="Region3"></dxi-column>                
                <dxi-column dataField="zip" dataType="string" cellTemplate="zipLinkCellTemplate" caption="ZIP" [width]="125" headerCellTemplate="boldHeaderTemplate"></dxi-column>
                <div *dxTemplate="let cell of 'zipLinkCellTemplate'"><a href="javascript:void(0)" (click)="zipSelected(cell.text)">{{cell.text}}</a></div>
                <dxi-column dataField="city" caption="City" [width]="145" headerCellTemplate="boldHeaderTemplate"></dxi-column>             
            </dx-data-grid>            
        </div>
    </dx-popup>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" 
        [visible]="!segmentsGetDone || !salesRegionGetDone || !territoriesGetDone || !countriesGetDone || !postCodeDetailsGetDone" 
        [showPane]="true"
        [shading]="false" 
        [closeOnOutsideClick]="false">
    </dx-load-panel>
    </div>
    </dxi-item>
    
</dx-accordion>

<div style="margin-top: 30px"></div>

<div *ngIf="showTabPanel">
    <ng-container #tabOutlet *ngTemplateOutlet="tabTemplate"></ng-container>
</div>
<ng-template #tabTemplate>
    <dx-tab-panel
        #crmOuterTabPanel
        [height]="inherit"
        [selectedIndex]="0"                
        [loop]="false"
        [deferRendering]="false"
        [animationEnabled]="false"        
        [swipeEnabled]="false"       
        [visible]="true">
        
        <dxi-item [title]="'Current Customer'" *ngIf="isReportSelected('Current Customer')">
            <app-crm-report-current-cust [reportRequest]="crmReportRequest"></app-crm-report-current-cust>
        </dxi-item>
        <dxi-item [title]="'Leads'" *ngIf="isReportSelected('Leads')">
            <app-crm-report-leads-open-lost-won [reportRequest]="crmReportRequest"></app-crm-report-leads-open-lost-won>
        </dxi-item>
        <dxi-item [title]="'Opportunities'" *ngIf="isReportSelected('Opportunities')">
            <app-crm-report-opportunities [reportRequest]="crmReportRequest"></app-crm-report-opportunities>
        </dxi-item>
        <dxi-item [title]="'CRM Prospects'" *ngIf="isReportSelected('CRM Prospects')">
            <app-crm-report-crm-prospects-with91-ma [reportRequest]="crmReportRequest"></app-crm-report-crm-prospects-with91-ma>
        </dxi-item>        
        <dxi-item [title]="'Suspects from D&B, all Segments'" *ngIf="isReportSelected('Suspects from D&B, all Segments')">
            <app-crm-report-crm-suspects [reportRequest]="crmReportRequest"></app-crm-report-crm-suspects>
        </dxi-item>
        
    </dx-tab-panel>
</ng-template>

